module.exports = __webpack_public_path__ + "img/crmakademi-logo.f7223dfe.svg";